<script>
	import { getContext, onDestroy } from 'svelte'
	import { slide } from 'svelte/transition'
	import { styles } from '../../library/scripts/styles'
	import {
		storeElementID,
		storeData,
		storeSelectedIcon,
		storeAnimate,
		storeShowGallery,
		storeSelectedTool,
	} from '../../library/scripts/Store.svelte'
	import { get_initial_values, get_element_tags, string_to_fontsize, get_blocks } from '../builderUtils'
	import { reorder_layout } from '../../library/scripts/utils'
	import ColorSelector from '../ColorSelector.svelte'
	import SelectValues from '../SelectValues.svelte'
	import SizeSelector from '../SizeSelector.svelte'
	import Shader from '../../library/ShadersAndSpinners/Shader.svelte'
	import Spinner from '../../library/ShadersAndSpinners/SpinnerCircle.svelte'

	export let width
	const globals = getContext('globals')
	const fsXL = globals.fsXL
	const fsX = globals.fsX
	const fsL = globals.fsL
	const fsN = globals.fsN
	const fsS = globals.fsS
	const fsXS = globals.fsXS
	const icon = globals.icon
	const iconColor = globals.colorDark
	const iconHover = globals.colorError
	let iconWeight = globals.colorDark
	let iconStyle = globals.colorDark
	let iconAlignL = globals.colorDark
	let iconAlignC = globals.colorDark
	let iconAlignR = globals.colorDark
	let iconValignT = globals.colorDark
	let iconValignC = globals.colorDark
	let iconValignB = globals.colorDark
	let iconAlignRL = globals.colorDark
	let iconAlignRC = globals.colorDark
	let iconAlignRR = globals.colorDark
	let mainTool = globals.mainTool
	let subTool = globals.subTool
	let mainToolHover = globals.mainToolHover
	let subToolHover = globals.subToolHover
	const fontFamily = globals.fontFamily
	const fontSize = globals.fontSize
	const fontSizeSmall = globals.fontSizeSmall

	let elementID
	let config
	let blocks
	let blockID

	//show hide tool
	let generalTool1 = false
	let generalTool2 = false
	let generalTool3 = false
	let showTool0 = false
	let showTool1 = false
	let showTool2 = false
	let showTool3 = false
	let showTool4 = false
	let showTool5 = false
	let showTool6 = false
	let showTool7 = false
	let showTool8 = false
	let showTool9 = false
	let showTool10 = false
	let showTool11 = false
	let showTool12 = false

	//the selectedIcon from store
	let selectedStoreIcon

	//change layout order
	let shaderChangeOrder = false

	//the values to send to sizeSelectors
	let selectedBorderWidth
	let selectedGalleryLeftBorderWidth
	let selectedGalleryRightBorderWidth

	//css selections
	let selectedBorderColor = 'hsla(0,0%,0%,1)'
	let selectedBackground
	let selectedColor
	let selectedBgOpac
	let selectedMarginTop
	let selectedMarginBottom
	let selectedPadding
	let selectedBLwidth
	let selectedBLcolor
	let selectedBTwidth
	let selectedBTcolor
	let selectedBRwidth
	let selectedBRcolor
	let selectedBBwidth
	let selectedBBcolor
	let selectedBTradius
	let selectedBBradius
	let selectedSliderWidth
	let selectedSliderHeight
	let selectedInsetWidth
	let selectedInsetHeight
	let selectedInsetLeft
	let selectedInsetTop
	let selectedInsetBackground
	let selectedInsetBgOpac
	let selectedIBLwidth
	let selectedIBLcolor
	let selectedIBTwidth
	let selectedIBTcolor
	let selectedIBRwidth
	let selectedIBRcolor
	let selectedIBBwidth
	let selectedIBBcolor
	let selectedIBradius
	let selectedItitleFont
	let selectedItitleColor
	let selectedItitleSize
	let selectedItitleWeight
	let selectedItitleStyle
	let selectedItitleOpac
	let selectedItextFont
	let selectedItextColor
	let selectedItextSize
	let selectedItextWeight
	let selectedItextStyle
	let selectedItextOpac
	let selectedLPadding
	let selectedLMarginTop
	let selectedLMarginBottom
	let selectedLBgColor
	let selectedLBgOpac
	let selectedLBTLradius
	let selectedLBTRradius
	let selectedLBBLradius
	let selectedLBBRradius
	let selectedLBbgImage
	let selectedLBcolor = 'hsla(0,0%,0%,1)'
	let selectedLBopac
	let selectedLBLwidth
	let selectedLBLstyle
	let selectedLBLcolor
	let selectedLBTwidth
	let selectedLBTstyle
	let selectedLBTcolor
	let selectedLBRwidth
	let selectedLBRstyle
	let selectedLBRcolor
	let selectedLBBwidth
	let selectedLBBstyle
	let selectedLBBcolor
	let selectedLFontColor
	let selectedLFontFamily
	let selectedLFontSize
	let selectedLFontWeight
	let selectedLFontStyle
	let selectedLFontAlign
	let selectedLFontValign
	let selectedLFontOpac
	let selectedRPadding
	let selectedRMarginTop
	let selectedRMarginBottom
	let selectedRBgColor
	let selectedRBgOpac
	let selectedRBTLradius
	let selectedRBTRradius
	let selectedRBBLradius
	let selectedRBBRradius
	let selectedRBbgImage
	let selectedRBLwidth
	let selectedRBLstyle
	let selectedRBLcolor
	let selectedRBTwidth
	let selectedRBTstyle
	let selectedRBTcolor
	let selectedRBRwidth
	let selectedRBRstyle
	let selectedRBRcolor
	let selectedRBBwidth
	let selectedRBBstyle
	let selectedRBBcolor
	let selectedRAlign
	let selectedRValign
	let selectedSColor
	let selectedSOpac
	let selectedSY
	let selectedSBlur
	let selectedSLeftColor
	let selectedSLeftOpac
	let selectedSLeftX
	let selectedSLeftY
	let selectedSLeftBlur
	let selectedSRightColor
	let selectedSRightOpac
	let selectedSRightX
	let selectedSRightY
	let selectedSRightBlur

	//icon selected
	let selectedIcon
	let selectedGicon

	//set icons
	let icon1 = false
	let icon2 = false
	let icon3 = false
	let icon4 = false
	let icon5 = false
	let icon6 = false
	let icon7 = false
	let icon8 = false
	let icon9 = false
	let icon10 = false
	let icon11 = false
	let icon12 = false
	let icon13 = false
	let icon14 = false
	let icon15 = false

	let icon1Color = iconColor
	let icon2Color = iconColor
	let icon3Color = iconColor
	let icon4Color = iconColor
	let icon5Color = iconColor
	let icon6Color = iconColor
	let icon7Color = iconColor
	let icon8Color = iconColor
	let icon9Color = iconColor
	let icon10Color = iconColor
	let icon11Color = iconColor
	let icon12Color = iconColor
	let icon13Color = iconColor
	let icon14Color = iconColor
	let icon15Color = iconColor

	//stative ID for getElementById in SelectValues
	let idSelect1 = 'selFont'
	let idSelect2 = 'selSize'

	const idColor1 = '100'
	const idColor2 = '101'
	const idColor3 = '102'
	const idColor4 = '103'
	const idColor5 = '104'
	const idColor6 = '105'
	const idColor7 = '106'
	const idColor8 = '107'
	const idColor9 = '108'
	const idColor10 = '109'
	const idMarginTop = '3'
	const idMarginBottom = '4'
	const idPadding = '5'
	const idBorderWidth = '6'
	const idGLB = '23'
	const idBTradius = '7'
	const idGLBTRadius = '24'
	const idGRBTRadius = '17'
	const idBBradius = '8'
	const idGLBBradius = '25'
	const idGRBBradius = '9'
	const idGRB = '18'
	const idGalleryClMt = '30'
	const idGalleryCrMt = '33'
	const idGalleryCrMb = '34'
	const idGalleryClMb = '31'
	const idGalleryClP = '32'
	const idGalleryCrP = '35'
	const idShadowY = '15'
	const idShadowBlur = '16'
	const idLeftShadowX = '54'
	const idLeftShadowY = '55'
	const idLeftShadowB = '13'
	const idRightShadowX = '36'
	const idRightShadowY = '37'
	const idRightShadowB = '38'

	//show border tools 1
	let iconP1Selected = false

	//show border tools 2
	let iconP2Selected = false

	//show border tools 3
	let iconP3Selected = false

	//animation
	let autoplay
	const stoAnimate = storeAnimate.subscribe((value) => {
		autoplay = value
	})

	const stoData = storeData.subscribe((value) => {
		if (value) {
			config = value
			blocks = value.blocks
		}
	})

	const stoElementID = storeElementID.subscribe((value) => {
		elementID = value
	})

	const stoSelectedIcon = storeSelectedIcon.subscribe((value) => {
		selectedStoreIcon = value
	})

	let showGallery
	const stoShowGallery = storeShowGallery.subscribe((value) => {
		showGallery = value
	})

	//set the initial css values from config.json
	$: if (elementID === 'gallery') {
		const tags = get_element_tags(elementID)
		blockID = tags[0]
		const values = get_initial_values(elementID, blocks, tags)
		selectedBackground = values[21][0]
		selectedBgOpac = values[21][1]
		selectedMarginTop = values[21][2]
		selectedMarginBottom = values[21][3]
		selectedPadding = values[21][4]
		selectedBLwidth = values[21][5]
		selectedBLcolor = values[21][6]
		selectedBTwidth = values[21][7]
		selectedBTcolor = values[21][8]
		selectedBRwidth = values[21][9]
		selectedBRcolor = values[21][10]
		selectedBBwidth = values[21][11]
		selectedBBcolor = values[21][12]
		selectedBTradius = values[21][13]
		selectedBBradius = values[21][14]
		selectedLPadding = values[22][0]
		selectedLMarginTop = values[22][1]
		selectedLMarginBottom = values[22][2]
		selectedLBgColor = values[22][3]
		selectedLBgOpac = values[22][4]
		selectedLBTLradius = values[22][5]
		selectedLBTRradius = values[22][6]
		selectedLBBLradius = values[22][7]
		selectedLBBRradius = values[22][8]
		selectedLBbgImage = values[22][9]
		selectedLBLwidth = values[22][10]
		selectedLBLstyle = values[22][11]
		selectedLBLcolor = values[22][12]
		selectedLBTwidth = values[22][13]
		selectedLBTstyle = values[22][14]
		selectedLBTcolor = values[22][15]
		selectedLBRwidth = values[22][16]
		selectedLBRstyle = values[22][17]
		selectedLBRcolor = values[22][18]
		selectedLBBwidth = values[22][19]
		selectedLBBstyle = values[22][20]
		selectedLBBcolor = values[22][21]
		selectedLBopac = values[22][22]
		selectedLFontColor = values[22][23]
		selectedLFontOpac = values[22][24]
		selectedLFontFamily = values[22][25]
		selectedLFontSize = values[22][26]
		selectedLFontWeight = values[22][27]
		selectedLFontStyle = values[22][28]
		set_fontstyle_initial_value(selectedLFontWeight, selectedLFontStyle)
		selectedLFontAlign = values[22][29]
		set_lc_icon_initial_value(selectedLFontAlign)
		selectedLFontValign = values[22][30]
		set_icon_lc_initial_value_vertical(selectedLFontValign)
		selectedRPadding = values[22][31]
		selectedRMarginTop = values[22][32]
		selectedRMarginBottom = values[22][33]
		selectedRBgColor = values[22][34]
		selectedRBgOpac = values[22][35]
		selectedRBTLradius = values[22][36]
		selectedRBTRradius = values[22][37]
		selectedRBBLradius = values[22][38]
		selectedRBBRradius = values[22][39]
		selectedRBbgImage = values[22][40]
		selectedRBLwidth = values[22][41]
		selectedRBLstyle = values[22][42]
		selectedRBLcolor = values[22][43]
		selectedRBTwidth = values[22][44]
		selectedRBTstyle = values[22][45]
		selectedRBTcolor = values[22][46]
		selectedRBRwidth = values[22][47]
		selectedRBRstyle = values[22][48]
		selectedRBRcolor = values[22][49]
		selectedRBBwidth = values[22][50]
		selectedRBBstyle = values[22][51]
		selectedRBBcolor = values[22][52]
		selectedRAlign = values[22][53]
		set_rc_icon_initial_value(selectedRAlign)
		selectedRValign = values[22][54]
		// set_icon_rc_initial_value_vertical(selectedRValign)
		selectedSColor = values[22][55]
		selectedSOpac = values[22][56]
		selectedSY = values[22][57]
		selectedSBlur = values[22][58]
		selectedSLeftColor = values[22][59]
		selectedSLeftOpac = values[22][60]
		selectedSLeftX = values[22][61]
		selectedSLeftY = values[22][62]
		selectedSLeftBlur = values[22][63]
		selectedSRightColor = values[22][64]
		selectedSRightOpac = values[22][65]
		selectedSRightX = values[22][66]
		selectedSRightY = values[22][67]
		selectedSRightBlur = values[22][68]

		if (selectedBLwidth > 0) {
			icon1 = true
			set_icon_color('left', 1)
		}
		if (selectedBTwidth > 0) {
			icon2 = true
			set_icon_color('top', 2)
		}

		if (selectedBRwidth > 0) {
			icon3 = true
			set_icon_color('right', 3)
		}

		if (selectedBBwidth > 0) {
			icon4 = true
			set_icon_color('bottom', 4)
		}

		if (selectedBLwidth > 0 && selectedBTwidth > 0 && selectedBRwidth > 0 && selectedBBwidth > 0) {
			icon1 = true
			icon2 = true
			icon3 = true
			icon4 = true
			icon5 = true
			set_icon_color('all', 5)
		}

		if (selectedLBLwidth > 0) {
			icon6 = true
			set_icon_color('left', 6)
		}
		if (selectedLBTwidth > 0) {
			icon7 = true
			set_icon_color('top', 7)
		}

		if (selectedLBRwidth > 0) {
			icon8 = true
			set_icon_color('right', 8)
		}

		if (selectedLBBwidth > 0) {
			icon9 = true
			set_icon_color('bottom', 9)
		}

		if (selectedLBLwidth > 0 && selectedLBTwidth > 0 && selectedLBRwidth > 0 && selectedLBBwidth > 0) {
			icon6 = true
			icon7 = true
			icon8 = true
			icon9 = true
			icon10 = true
			set_icon_color('all', 10)
		}

		if (selectedRBLwidth > 0) {
			icon11 = true
			set_icon_color('left', 11)
		}
		if (selectedRBTwidth > 0) {
			icon12 = true
			set_icon_color('top', 12)
		}

		if (selectedRBRwidth > 0) {
			icon13 = true
			set_icon_color('right', 13)
		}

		if (selectedRBBwidth > 0) {
			icon14 = true
			set_icon_color('bottom', 14)
		}

		if (selectedRBLwidth > 0 && selectedRBTwidth > 0 && selectedRBRwidth > 0 && selectedRBBwidth > 0) {
			icon11 = true
			icon12 = true
			icon13 = true
			icon14 = true
			icon15 = true
			set_icon_color('all', 15)
		}
	}

	$: if (!icon1 && !icon2 && !icon3 && !icon4 && !icon5) iconP1Selected = false
	$: if (!icon6 && !icon7 && !icon8 && !icon9 && !icon10) iconP2Selected = false
	$: if (!icon11 && !icon12 && !icon13 && !icon14 && !icon15) iconP3Selected = false

	$: if (selectedStoreIcon === 'icon1') selectedBorderWidth = selectedBLwidth
	$: if (selectedStoreIcon === 'icon2') selectedBorderWidth = selectedBTwidth
	$: if (selectedStoreIcon === 'icon3') selectedBorderWidth = selectedBRwidth
	$: if (selectedStoreIcon === 'icon4') selectedBorderWidth = selectedBBwidth
	$: if (selectedStoreIcon === 'icon5') selectedBorderWidth = selectedBLwidth
	$: if (selectedStoreIcon === 'icon6') selectedGalleryLeftBorderWidth = selectedLBLwidth
	$: if (selectedStoreIcon === 'icon7') selectedGalleryLeftBorderWidth = selectedLBTwidth
	$: if (selectedStoreIcon === 'icon8') selectedGalleryLeftBorderWidth = selectedLBRwidth
	$: if (selectedStoreIcon === 'icon9') selectedGalleryLeftBorderWidth = selectedLBBwidth
	$: if (selectedStoreIcon === 'icon10') selectedGalleryLeftBorderWidth = selectedLBLwidth
	$: if (selectedStoreIcon === 'icon11') selectedGalleryRightBorderWidth = selectedRBLwidth
	$: if (selectedStoreIcon === 'icon12') selectedGalleryRightBorderWidth = selectedRBTwidth
	$: if (selectedStoreIcon === 'icon13') selectedGalleryRightBorderWidth = selectedRBRwidth
	$: if (selectedStoreIcon === 'icon14') selectedGalleryRightBorderWidth = selectedRBBwidth
	$: if (selectedStoreIcon === 'icon15') selectedGalleryRightBorderWidth = selectedRBLwidth

	const set_icon_color = (c, iNum) => {
		if (c === 'left') {
			if (iNum === 1) icon1Color = iconHover
			if (iNum === 6) icon6Color = iconHover
			if (iNum === 11) icon11Color = iconHover
		}
		if (c === 'top') {
			if (iNum === 2) icon2Color = iconHover
			if (iNum === 7) icon7Color = iconHover
			if (iNum === 12) icon12Color = iconHover
		}
		if (c === 'right') {
			if (iNum === 3) icon3Color = iconHover
			if (iNum === 8) icon8Color = iconHover
			if (iNum === 13) icon13Color = iconHover
		}
		if (c === 'bottom') {
			if (iNum === 4) icon4Color = iconHover
			if (iNum === 9) icon9Color = iconHover
			if (iNum === 14) icon14Color = iconHover
		}
		if (c === 'all') {
			if (iNum === 5) {
				icon1Color = iconHover
				icon2Color = iconHover
				icon3Color = iconHover
				icon4Color = iconHover
				icon5Color = iconHover
			}

			if (iNum === 10) {
				icon6Color = iconHover
				icon7Color = iconHover
				icon8Color = iconHover
				icon9Color = iconHover
				icon10Color = iconHover
			}

			if (iNum === 15) {
				icon11Color = iconHover
				icon12Color = iconHover
				icon13Color = iconHover
				icon14Color = iconHover
				icon15Color = iconHover
			}
		}
		if (c === 'none') {
			if (iNum === 5) {
				icon1Color = iconColor
				icon2Color = iconColor
				icon3Color = iconColor
				icon4Color = iconColor
				icon5Color = iconColor
			}
			if (iNum === 10) {
				icon6Color = iconColor
				icon7Color = iconColor
				icon8Color = iconColor
				icon9Color = iconColor
				icon10Color = iconColor
			}

			if (iNum === 15) {
				icon11Color = iconColor
				icon12Color = iconColor
				icon13Color = iconColor
				icon14Color = iconColor
				icon15Color = iconColor
			}
		}
	}

	const set_css_tag = (cssTag, cmd) => {
		blocks.forEach((block) => {
			if (block.blockName === blockID) {
				if (cmd === 'bg') {
					block.backgroundColor = cssTag
				}

				if (cmd === 'galleryIFF') block.introFontFamily = cssTag

				if (cmd === 'galleryIFS') block.introFontSize = cssTag

				if (cmd === 'fontText') block.sliderInsetTextFont = cssTag

				if (cmd === 'sizeText') block.sliderInsetTextSize = cssTag

				if (cmd === 'introFontColor') block.introFontColor = cssTag

				if (cmd === 'insetTextColor') block.sliderInsetTextColor = cssTag

				if (cmd === 'gIFW') block.introFontWeight = block.introFontWeight === 'bold' ? 'normal' : 'bold'

				if (cmd === 'sC') block.galleryShadowColor = cssTag

				if (cmd === 'sY') block.galleryShadowY = cssTag

				if (cmd === 'sB') block.galleryShadowBlur = cssTag

				if (cmd === 'gIFS') block.introFontStyle = block.introFontStyle === 'italic' ? 'normal' : 'italic'

				if (cmd === 'galleryLcBg') block.galleryLeftBackgroundColor = cssTag

				if (cmd === 'galleryRcBg') block.galleryRightBackgroundColor = cssTag

				if (cmd === 'bL') {
					if (icon1 && selectedIcon === 'icon1') {
						block.borderLeftColor = cssTag
						block.borderLeftWidth = '1'
						icon1Color = iconHover
						if (icon1 && icon2 && icon3 && icon4) icon5Color = iconHover
					} else {
						block.borderLeftWidth = '0'
						icon1Color = iconColor
						icon5Color = iconColor
					}
				}

				if (cmd === 'gLBL') {
					if (icon6 && selectedGicon === 'icon6') {
						block.galleryLeftBorderLeftColor = cssTag
						block.galleryLeftBorderLeftWidth = '1'
						icon6Color = iconHover
						if (icon6 && icon7 && icon8 && icon9) icon10Color = iconHover
					} else {
						block.galleryLeftBorderLeftWidth = '0'
						icon6Color = iconColor
						icon10Color = iconColor
					}
				}

				if (cmd === 'gRBL') {
					if (icon11 && selectedGicon === 'icon11') {
						block.galleryRightBorderLeftColor = cssTag
						block.galleryRightBorderLeftWidth = '1'
						icon11Color = iconHover
						if (icon11 && icon12 && icon13 && icon14) icon15Color = iconHover
					} else {
						block.galleryRightBorderLeftWidth = '0'
						icon11Color = iconColor
						icon15Color = iconColor
					}
				}

				if (cmd === 'bT') {
					if (icon2 && selectedIcon === 'icon2') {
						block.borderTopColor = cssTag
						block.borderTopWidth = '1'
						icon2Color = iconHover
						if (icon1 && icon2 && icon3 && icon4) icon5Color = iconHover
					} else {
						block.borderTopWidth = '0'
						icon2Color = iconColor
						icon5Color = iconColor
					}
				}

				if (cmd === 'gLBT') {
					if (icon7 && selectedGicon === 'icon7') {
						block.galleryLeftBorderTopColor = cssTag
						block.galleryLeftBorderTopWidth = '1'
						icon7Color = iconHover
						if (icon6 && icon7 && icon8 && icon9) icon10Color = iconHover
					} else {
						block.galleryLeftBorderTopWidth = '0'
						icon7Color = iconColor
						icon10Color = iconColor
					}
				}

				if (cmd === 'gRBT') {
					if (icon12 && selectedGicon === 'icon12') {
						block.galleryRightBorderTopColor = cssTag
						block.galleryRightBorderTopWidth = '1'
						icon12Color = iconHover
						if (icon11 && icon12 && icon13 && icon14) icon15Color = iconHover
					} else {
						block.galleryRightBorderTopWidth = '0'
						icon12Color = iconColor
						icon15Color = iconColor
					}
				}

				if (cmd === 'bR') {
					if (icon3 && selectedIcon === 'icon3') {
						block.borderRightColor = cssTag
						block.borderRightWidth = '1'
						icon3Color = iconHover
						if (icon1 && icon2 && icon3 && icon4) icon5Color = iconHover
					} else {
						block.borderRightWidth = '0'
						icon3Color = iconColor
						icon5Color = iconColor
					}
				}

				if (cmd === 'gLBR') {
					if (icon8 && selectedGicon === 'icon8') {
						block.galleryLeftBorderRightColor = cssTag
						block.galleryLeftBorderRightWidth = '1'
						icon8Color = iconHover
						if (icon6 && icon7 && icon8 && icon9) icon10Color = iconHover
					} else {
						block.galleryLeftBorderRightWidth = '0'
						icon8Color = iconColor
						icon10Color = iconColor
					}
				}

				if (cmd === 'gRBR') {
					if (icon13 && selectedGicon === 'icon13') {
						block.galleryRightBorderRightColor = cssTag
						block.galleryRightBorderRightWidth = '1'
						icon13Color = iconHover
						if (icon11 && icon12 && icon13 && icon14) icon15Color = iconHover
					} else {
						block.galleryRightBorderRightWidth = '0'
						icon13Color = iconColor
						icon15Color = iconColor
					}
				}

				if (cmd === 'bB') {
					if (icon4 && selectedIcon === 'icon4') {
						block.borderBottomColor = cssTag
						block.borderBottomWidth = '1'
						icon4Color = iconHover
						if (icon1 && icon2 && icon3 && icon4) icon5Color = iconHover
					} else {
						block.borderBottomWidth = '0'
						icon4Color = iconColor
						icon5Color = iconColor
					}
				}

				if (cmd === 'gLBB') {
					if (icon9 && selectedGicon === 'icon9') {
						block.galleryLeftBorderBottomColor = cssTag
						block.galleryLeftBorderBottomWidth = '1'
						icon9Color = iconHover
						if (icon6 && icon7 && icon8 && icon9) icon10Color = iconHover
					} else {
						block.galleryLeftBorderBottomWidth = '0'
						icon9Color = iconColor
						icon10Color = iconColor
					}
				}

				if (cmd === 'gRBB') {
					if (icon14 && selectedGicon === 'icon14') {
						block.galleryRightBorderBottomColor = cssTag
						block.galleryRightBorderBottomWidth = '1'
						icon14Color = iconHover
						if (icon11 && icon12 && icon13 && icon14) icon15Color = iconHover
					} else {
						block.galleryRightBorderBottomWidth = '0'
						icon14Color = iconColor
						icon15Color = iconColor
					}
				}

				if (cmd === 'bA') {
					if (icon5 && selectedIcon === 'icon5') {
						block.borderLeftColor = cssTag
						block.borderLeftWidth = '1'
						block.borderTopColor = cssTag
						block.borderTopWidth = '1'
						block.borderRightColor = cssTag
						block.borderRightWidth = '1'
						block.borderBottomColor = cssTag
						block.borderBottomWidth = '1'
						icon5Color = iconHover
						icon1Color = iconHover
						icon2Color = iconHover
						icon3Color = iconHover
						icon4Color = iconHover
					} else {
						block.borderLeftWidth = '0'
						block.borderTopWidth = '0'
						block.borderRightWidth = '0'
						block.borderBottomWidth = '0'
						icon5Color = iconColor
						icon1Color = iconColor
						icon2Color = iconColor
						icon3Color = iconColor
						icon4Color = iconColor

						icon1 = false
						icon2 = false
						icon3 = false
						icon4 = false
						icon5 = false
					}
				}

				if (cmd === 'gLBA') {
					if (icon10 && selectedGicon === 'icon10') {
						block.galleryLeftBorderLeftColor = cssTag
						block.galleryLeftBorderLeftWidth = '1'
						block.galleryLeftBorderTopColor = cssTag
						block.galleryLeftBorderTopWidth = '1'
						block.galleryLeftBorderRightColor = cssTag
						block.galleryLeftBorderRightWidth = '1'
						block.galleryLeftBorderBottomColor = cssTag
						block.galleryLeftBorderBottomWidth = '1'
						icon10Color = iconHover
						icon6Color = iconHover
						icon7Color = iconHover
						icon8Color = iconHover
						icon9Color = iconHover
					} else {
						block.galleryLeftBorderLeftWidth = '0'
						block.galleryLeftBorderTopWidth = '0'
						block.galleryLeftBorderRightWidth = '0'
						block.galleryLeftBorderBottomWidth = '0'
						icon10Color = iconColor
						icon6Color = iconColor
						icon7Color = iconColor
						icon8Color = iconColor
						icon9Color = iconColor

						icon6 = false
						icon7 = false
						icon8 = false
						icon9 = false
						icon10 = false
					}
				}

				if (cmd === 'gRBA') {
					if (icon15 && selectedGicon === 'icon15') {
						block.galleryRightBorderLeftColor = cssTag
						block.galleryRightBorderLeftWidth = '1'
						block.galleryRightBorderTopColor = cssTag
						block.galleryRightBorderTopWidth = '1'
						block.galleryRightBorderRightColor = cssTag
						block.galleryRightBorderRightWidth = '1'
						block.galleryRightBorderBottomColor = cssTag
						block.galleryRightBorderBottomWidth = '1'
						icon15Color = iconHover
						icon11Color = iconHover
						icon12Color = iconHover
						icon13Color = iconHover
						icon14Color = iconHover
					} else {
						block.galleryRightBorderLeftWidth = '0'
						block.galleryRightBorderTopWidth = '0'
						block.galleryRightBorderRightWidth = '0'
						block.galleryRightBorderBottomWidth = '0'
						icon15Color = iconColor
						icon11Color = iconColor
						icon12Color = iconColor
						icon13Color = iconColor
						icon14Color = iconColor

						icon11 = false
						icon12 = false
						icon13 = false
						icon14 = false
						icon15 = false
					}
				}

				if (cmd === 'bWidth') {
					if (icon1 && selectedIcon === 'icon1') block.borderLeftWidth = cssTag
					if (icon2 && selectedIcon === 'icon2') block.borderTopWidth = cssTag
					if (icon3 && selectedIcon === 'icon3') block.borderRightWidth = cssTag
					if (icon4 && selectedIcon === 'icon4') block.borderBottomWidth = cssTag
					if (icon5 && selectedIcon === 'icon5') {
						block.borderLeftWidth = cssTag
						block.borderTopWidth = cssTag
						block.borderRightWidth = cssTag
						block.borderBottomWidth = cssTag
					}
				}

				if (cmd === 'gLBW') {
					if (icon6 && selectedGicon === 'icon6') block.galleryLeftBorderLeftWidth = cssTag
					if (icon7 && selectedGicon === 'icon7') block.galleryLeftBorderTopWidth = cssTag
					if (icon8 && selectedGicon === 'icon8') block.galleryLeftBorderRightWidth = cssTag
					if (icon9 && selectedGicon === 'icon9') block.galleryLeftBorderBottomWidth = cssTag
					if (icon10 && selectedGicon === 'icon10') {
						block.galleryLeftBorderLeftWidth = cssTag
						block.galleryLeftBorderTopWidth = cssTag
						block.galleryLeftBorderRightWidth = cssTag
						block.galleryLeftBorderBottomWidth = cssTag
					}
				}

				if (cmd === 'gRBW') {
					if (icon11 && selectedGicon === 'icon11') block.galleryRightBorderLeftWidth = cssTag
					if (icon12 && selectedGicon === 'icon12') block.galleryRightBorderTopWidth = cssTag
					if (icon13 && selectedGicon === 'icon13') block.galleryRightBorderRightWidth = cssTag
					if (icon14 && selectedGicon === 'icon14') block.galleryRightBorderBottomWidth = cssTag
					if (icon15 && selectedGicon === 'icon15') {
						block.galleryRightBorderLeftWidth = cssTag
						block.galleryRightBorderTopWidth = cssTag
						block.galleryRightBorderRightWidth = cssTag
						block.galleryRightBorderBottomWidth = cssTag
					}
				}

				if (cmd === 'bColor' || cmd === 'bOpacity') {
					if (icon1 && selectedIcon === 'icon1') block.borderLeftColor = cssTag
					if (icon2 && selectedIcon === 'icon2') block.borderTopColor = cssTag
					if (icon3 && selectedIcon === 'icon3') block.borderRightColor = cssTag
					if (icon4 && selectedIcon === 'icon4') block.borderBottomColor = cssTag
					if (icon5 && selectedIcon === 'icon5') {
						block.borderLeftColor = cssTag
						block.borderTopColor = cssTag
						block.borderRightColor = cssTag
						block.borderBottomColor = cssTag
					}
				}

				if (cmd === 'gLBC') {
					if (icon6 && selectedGicon === 'icon6') block.galleryLeftBorderLeftColor = cssTag
					if (icon7 && selectedGicon === 'icon7') block.galleryLeftBorderTopColor = cssTag
					if (icon8 && selectedGicon === 'icon8') block.galleryLeftBorderRightColor = cssTag
					if (icon9 && selectedGicon === 'icon9') block.galleryLeftBorderBottomColor = cssTag
					if (icon10 && selectedGicon === 'icon10') {
						block.galleryLeftBorderLeftColor = cssTag
						block.galleryLeftBorderTopColor = cssTag
						block.galleryLeftBorderRightColor = cssTag
						block.galleryLeftBorderBottomColor = cssTag
					}
				}

				if (cmd === 'gRBC') {
					if (icon11 && selectedGicon === 'icon11') block.galleryRightBorderLeftColor = cssTag
					if (icon12 && selectedGicon === 'icon12') block.galleryRightBorderTopColor = cssTag
					if (icon13 && selectedGicon === 'icon13') block.galleryRightBorderRightColor = cssTag
					if (icon14 && selectedGicon === 'icon14') block.galleryRightBorderBottomColor = cssTag
					if (icon15 && selectedGicon === 'icon15') {
						block.galleryRightBorderLeftColor = cssTag
						block.galleryRightBorderTopColor = cssTag
						block.galleryRightBorderRightColor = cssTag
						block.galleryRightBorderBottomColor = cssTag
					}
				}

				if (cmd === 'GRSC') block.galleryRightShadowColor = cssTag

				if (cmd === 'GRSX') block.galleryRightShadowOffsetX = cssTag

				if (cmd === 'GRSY') block.galleryRightShadowOffsetY = cssTag

				if (cmd === 'GRSB') block.galleryRightShadowBlur = cssTag

				if (cmd === 'GLSC') block.galleryLeftShadowColor = cssTag

				if (cmd === 'GLSX') block.galleryLeftShadowOffsetX = cssTag

				if (cmd === 'GLSY') block.galleryLeftShadowOffsetY = cssTag

				if (cmd === 'GLSB') block.galleryLeftShadowBlur = cssTag

				if (cmd === 'btRadius') block.borderTopRadius = cssTag

				if (cmd === 'gLBTradius') block.galleryLeftBorderTopRadius = cssTag

				if (cmd === 'gRBTradius') block.galleryRightBorderTopRadius = cssTag

				if (cmd === 'bbRadius') block.borderBottomRadius = cssTag

				if (cmd === 'gBBradius') block.galleryLeftBorderBottomRadius = cssTag

				if (cmd === 'gRBBradius') block.galleryRightBorderBottomRadius = cssTag

				if (cmd === 'flexAlign') block.galleryLeftAlign = cssTag

				if (cmd === 'flexValign') block.galleryLeftValign = cssTag

				if (cmd === 'flexRAlign') block.galleryRightAlign = cssTag

				if (cmd === 'flexRValign') block.galleryRightValign = cssTag
			}
		})

		config.blocks = blocks
		storeData.set(config)
	}

	const set_lc_icon_initial_value = (v) => {
		if (v) {
			if (v === 'flex-start') {
				iconAlignL = iconHover
				iconAlignC = iconColor
				iconAlignR = iconColor
				return
			}

			if (v === 'left') {
				iconAlignL = iconHover
				iconAlignC = iconColor
				iconAlignR = iconColor
				return
			}
			if (v === 'center') {
				iconAlignL = iconColor
				iconAlignC = iconHover
				iconAlignR = iconColor
				return
			}

			if (v === 'flex-end') {
				iconAlignL = iconColor
				iconAlignC = iconColor
				iconAlignR = iconHover
				return
			}

			if (v === 'right') {
				iconAlignL = iconColor
				iconAlignC = iconColor
				iconAlignR = iconHover
				return
			}
		}
	}

	const set_rc_icon_initial_value = (v) => {
		if (v) {
			if (v === 'flex-start') {
				iconAlignRL = iconHover
				iconAlignRC = iconColor
				iconAlignRR = iconColor
				return
			}
			if (v === 'center') {
				iconAlignRL = iconColor
				iconAlignRC = iconHover
				iconAlignRR = iconColor
				return
			}

			if (v === 'flex-end') {
				iconAlignRL = iconColor
				iconAlignRC = iconColor
				iconAlignRR = iconHover
				return
			}
		}
	}

	const set_icon_lc_initial_value_vertical = (v) => {
		if (v) {
			if (v === 'flex-start') {
				iconValignT = iconHover
				iconValignC = iconColor
				iconValignB = iconColor
				return
			}
			if (v === 'center') {
				iconValignT = iconColor
				iconValignC = iconHover
				iconValignB = iconColor
				return
			}

			if (v === 'flex-end') {
				iconValignT = iconColor
				iconValignC = iconColor
				iconValignB = iconHover
				return
			}
		}
	}

	const set_fontstyle_initial_value = (w, s) => {
		if (w === 'bold') iconWeight = iconHover
		if (w === 'normal') iconWeight = iconColor
		if (s === 'italic') iconStyle = iconHover
		if (s === 'normal') iconStyle = iconColor
	}

	const set_bg_color = (e) => {
		set_css_tag(e.detail.color, 'bg')
	}

	const set_gallery_intro_font_color = (e) => {
		set_css_tag(e.detail.color, 'introFontColor')
	}

	const set_gallery_border_color = (e) => {
		set_css_tag(e.detail.color, 'bColor')
	}

	const set_gallery_left_border_color = (e) => {
		set_css_tag(e.detail.color, 'gLBC')
	}

	const set_gallery_right_border_color = (e) => {
		set_css_tag(e.detail.color, 'gRBC')
	}

	const set_gallery_right_shadow_color = (e) => {
		set_css_tag(e.detail.color, 'GRSC')
	}

	const set_gallery_right_shadow_x = (e) => {
		set_css_tag(e.detail.value, 'GRSX')
	}

	const set_gallery_right_shadow_y = (e) => {
		set_css_tag(e.detail.value, 'GRSY')
	}

	const set_gallery_right_shadow_blur = (e) => {
		set_css_tag(e.detail.value, 'GRSB')
	}

	const set_gallery_left_shadow_color = (e) => {
		set_css_tag(e.detail.color, 'GLSC')
	}

	const set_gallery_left_shadow_x = (e) => {
		set_css_tag(e.detail.value, 'GLSX')
	}

	const set_gallery_left_shadow_y = (e) => {
		set_css_tag(e.detail.value, 'GLSY')
	}

	const set_gallery_left_shadow_blur = (e) => {
		set_css_tag(e.detail.value, 'GLSB')
	}

	const set_border_width = (e) => {
		set_css_tag(e.detail.value, 'bWidth')
	}

	const set_border_top_radius = (e) => {
		set_css_tag(e.detail.value, 'btRadius')
	}

	const set_gallery_left_border_top_radius = (e) => {
		set_css_tag(e.detail.value, 'gLBTradius')
	}

	const set_gallery_right_border_top_radius = (e) => {
		set_css_tag(e.detail.value, 'gRBTradius')
	}

	const set_border_bottom_radius = (e) => {
		set_css_tag(e.detail.value, 'bbRadius')
	}

	const set_gallery_left_border_bottom_radius = (e) => {
		set_css_tag(e.detail.value, 'gBBradius')
	}

	const set_gallery_right_border_bottom_radius = (e) => {
		set_css_tag(e.detail.value, 'gRBBradius')
	}

	const set_gallery_intro_font_weight = () => {
		set_css_tag(null, 'gIFW')
	}

	const set_gallery_left_font_style = () => {
		set_css_tag(null, 'gIFS')
	}

	const set_gallery_lc_bg_color = (e) => {
		set_css_tag(e.detail.color, 'galleryLcBg')
	}

	const set_gallery_rc_bg_color = (e) => {
		set_css_tag(e.detail.color, 'galleryRcBg')
	}

	const set_gallery_lc_margin_top = (e) => {
		blocks.forEach((block) => {
			if (block.blockName === blockID) {
				block.galleryLeftMarginTop = e.detail.value
				config.blocks = blocks
				storeData.set(config)
			}
		})
	}

	const set_gallery_rc_margin_top = (e) => {
		blocks.forEach((block) => {
			if (block.blockName === blockID) {
				block.galleryRightMarginTop = e.detail.value
				config.blocks = blocks
				storeData.set(config)
			}
		})
	}

	const set_gallery_lc_margin_bottom = (e) => {
		blocks.forEach((block) => {
			if (block.blockName === blockID) {
				block.galleryLeftMarginBottom = e.detail.value
				config.blocks = blocks
				storeData.set(config)
			}
		})
	}

	const set_gallery_rc_margin_bottom = (e) => {
		blocks.forEach((block) => {
			if (block.blockName === blockID) {
				block.galleryRightMarginBottom = e.detail.value
				config.blocks = blocks
				storeData.set(config)
			}
		})
	}

	const set_gallery_lc_padding = (e) => {
		blocks.forEach((block) => {
			if (block.blockName === blockID) {
				block.galleryLeftPadding = e.detail.value
				config.blocks = blocks
				storeData.set(config)
			}
		})
	}

	const set_gallery_rc_padding = (e) => {
		blocks.forEach((block) => {
			if (block.blockName === blockID) {
				block.galleryRightPadding = e.detail.value
				config.blocks = blocks
				storeData.set(config)
			}
		})
	}

	const set_gallery_left_border_width = (e) => {
		set_css_tag(e.detail.value, 'gLBW')
	}

	const set_gallery_right_border_width = (e) => {
		set_css_tag(e.detail.value, 'gRBW')
	}

	const set_gallery_intro_align = (a) => {
		set_css_tag(a, 'flexAlign')
	}

	const set_gallery_right_align_left = () => {
		set_css_tag('flex-start', 'flexRAlign')
	}

	const set_gallery_right_align_center = () => {
		set_css_tag('center', 'flexRAlign')
	}

	const set_gallery_right_align_right = () => {
		set_css_tag('flex-end', 'flexRAlign')
	}

	const set_gallery_left_valign_top = () => {
		set_css_tag('flex-start', 'flexValign')
	}

	const set_gallery_right_valign_top = () => {
		set_css_tag('flex-start', 'flexRValign')
	}

	const set_gallery_left_valign_center = () => {
		set_css_tag('center', 'flexValign')
	}

	const set_gallery_right_valign_center = () => {
		set_css_tag('center', 'flexRValign')
	}

	const set_gallery_left_valign_bottom = () => {
		set_css_tag('flex-end', 'flexValign')
	}

	const set_gallery_right_valign_bottom = () => {
		set_css_tag('flex-end', 'flexRValign')
	}

	const set_margin_top = (e) => {
		blocks.forEach((block) => {
			if (block.blockName === blockID) {
				block.marginTop = e.detail.value
				config.blocks = blocks
				storeData.set(config)
			}
		})
	}

	const set_margin_bottom = (e) => {
		blocks.forEach((block) => {
			if (block.blockName === blockID) {
				block.marginBottom = e.detail.value
				config.blocks = blocks
				storeData.set(config)
			}
		})
	}

	const set_padding = (e) => {
		blocks.forEach((block) => {
			if (block.blockName === blockID) {
				block.padding = e.detail.value
				config.blocks = blocks
				storeData.set(config)
			}
		})
	}

	const set_gallery_intro_font_family = (e) => {
		set_css_tag(e.detail.font, 'galleryIFF')
	}

	const set_gallery_left_font_size = (e) => {
		const size = string_to_fontsize(e.detail.size)
		set_css_tag(size, 'galleryIFS')
	}

	const set_shadow_color = (e) => {
		set_css_tag(e.detail.color, 'sC')
	}

	const set_offset_y = (e) => {
		set_css_tag(e.detail.value, 'sY')
	}

	const set_blur = (e) => {
		set_css_tag(e.detail.value, 'sB')
	}

	const set_icon_1 = () => {
		iconP1Selected = true
		selectedIcon = 'icon1'
		storeSelectedIcon.set('icon1')
		icon1 = icon1 === false ? true : false
		if (icon1) icon1Color = iconHover
		else icon1Color = iconColor
		set_css_tag('hsla(0,0%,0%,1)', 'bL')
	}

	const set_icon_2 = () => {
		iconP1Selected = true
		selectedIcon = 'icon2'
		storeSelectedIcon.set('icon2')
		icon2 = icon2 === false ? true : false
		if (icon2) icon2Color = iconHover
		else icon2Color = iconColor
		set_css_tag('hsla(0,0%,0%,1)', 'bT')
	}

	const set_icon_3 = () => {
		iconP1Selected = true
		selectedIcon = 'icon3'
		storeSelectedIcon.set('icon3')
		icon3 = icon3 === false ? true : false
		if (icon3) icon3Color = iconHover
		else icon3Color = iconColor
		set_css_tag('hsla(0,0%,0%,1)', 'bR')
	}

	const set_icon_4 = () => {
		iconP1Selected = true
		selectedIcon = 'icon4'
		storeSelectedIcon.set('icon4')
		icon4 = icon4 === false ? true : false
		if (icon4) icon4Color = iconHover
		else icon4Color = iconColor
		set_css_tag('hsla(0,0%,0%,1)', 'bB')
	}

	const set_icon_5 = () => {
		iconP1Selected = true
		selectedIcon = 'icon5'
		storeSelectedIcon.set('icon5')
		icon5 = icon5 === false ? true : false
		if (icon5) icon5Color = iconHover
		else icon5Color = iconColor
		set_css_tag('hsla(0,0%,0%,1)', 'bA')
	}

	const set_icon_6 = () => {
		iconP2Selected = true
		selectedGicon = 'icon6'
		storeSelectedIcon.set('icon6')
		icon6 = icon6 === false ? true : false
		if (icon6) icon6Color = iconHover
		else icon6Color = iconColor
		set_css_tag('hsla(0,0%,0%,1)', 'gLBL')
	}

	const set_icon_7 = () => {
		iconP2Selected = true
		selectedGicon = 'icon7'
		storeSelectedIcon.set('icon7')
		icon7 = icon7 === false ? true : false
		if (icon7) icon7Color = iconHover
		else icon7Color = iconColor
		set_css_tag('hsla(0,0%,0%,1)', 'gLBT')
	}

	const set_icon_8 = () => {
		iconP2Selected = true
		selectedGicon = 'icon8'
		storeSelectedIcon.set('icon8')
		icon8 = icon8 === false ? true : false
		if (icon8) icon8Color = iconHover
		else icon8Color = iconColor
		set_css_tag('hsla(0,0%,0%,1)', 'gLBR')
	}

	const set_icon_9 = () => {
		iconP2Selected = true
		selectedGicon = 'icon9'
		storeSelectedIcon.set('icon9')
		icon9 = icon9 === false ? true : false
		if (icon9) icon9Color = iconHover
		else icon9Color = iconColor
		set_css_tag('hsla(0,0%,0%,1)', 'gLBB')
	}

	const set_icon_10 = () => {
		iconP2Selected = true
		selectedGicon = 'icon10'
		storeSelectedIcon.set('icon10')
		icon10 = icon10 === false ? true : false
		if (icon10) icon10Color = iconHover
		else icon10Color = iconColor
		set_css_tag('hsla(0,0%,0%,1)', 'gLBA')
	}

	const set_icon_11 = () => {
		iconP3Selected = true
		selectedGicon = 'icon11'
		storeSelectedIcon.set('icon11')
		icon11 = icon11 === false ? true : false
		if (icon11) icon11Color = iconHover
		else icon11Color = iconColor
		set_css_tag('hsla(0,0%,0%,1)', 'gRBL')
	}

	const set_icon_12 = () => {
		iconP3Selected = true
		selectedGicon = 'icon12'
		storeSelectedIcon.set('icon12')
		icon12 = icon12 === false ? true : false
		if (icon12) icon12Color = iconHover
		else icon12Color = iconColor
		set_css_tag('hsla(0,0%,0%,1)', 'gRBT')
	}

	const set_icon_13 = () => {
		iconP3Selected = true
		selectedGicon = 'icon13'
		storeSelectedIcon.set('icon13')
		icon13 = icon13 === false ? true : false
		if (icon13) icon13Color = iconHover
		else icon13Color = iconColor
		set_css_tag('hsla(0,0%,0%,1)', 'gRBR')
	}

	const set_icon_14 = () => {
		iconP3Selected = true
		selectedGicon = 'icon14'
		storeSelectedIcon.set('icon14')
		icon14 = icon14 === false ? true : false
		if (icon14) icon14Color = iconHover
		else icon14Color = iconColor
		set_css_tag('hsla(0,0%,0%,1)', 'gRBB')
	}

	const set_icon_15 = () => {
		iconP3Selected = true
		selectedGicon = 'icon15'
		storeSelectedIcon.set('icon15')
		icon15 = icon15 === false ? true : false
		if (icon15) icon15Color = iconHover
		else icon15Color = iconColor
		set_css_tag('hsla(0,0%,0%,1)', 'gRBA')
	}

	const change_order = async (block, direction) => {
		let changeOrder = true
		blocks = get_blocks(config)
		blocks.forEach((bl) => {
			if (bl.blockName === block && bl.layoutOrder === 0 && direction === 'up') {
				changeOrder = false
			}

			if (bl.blockName === block && bl.layoutOrder === blocks.length - 1 && direction === 'down') {
				changeOrder = false
			}
		})
		if (changeOrder) {
			shaderChangeOrder = true
			const reorder = await reorder_layout(block, direction)
			storeData.set(reorder)
			shaderChangeOrder = false
		}
	}

	const set_elementID = (e) => {
		elementID = e
		storeElementID.set(e)
	}

	const open_set_modal = () => {
		showGallery = showGallery === true ? false : true
		storeShowGallery.set(showGallery)
		storeSelectedTool.set('GalleryModal')
	}

	let toTool
	const open_tool = (t) => {
		switch (t) {
			case 'generalTool1':
				generalTool1 = generalTool1 === false ? true : false
				showTool2 = false
				showTool3 = false
				break

			case 'generalTool2':
				generalTool2 = generalTool2 === false ? true : false
				showTool5 = false
				showTool6 = false
				showTool7 = false
				showTool8 = false
				break

			case 'generalTool3':
				generalTool3 = generalTool3 === false ? true : false
				showTool10 = false
				showTool11 = false
				showTool12 = false
				break

			case 0:
				showTool0 = showTool0 === true ? false : true
				showTool1 = false
				showTool4 = false
				showTool9 = false
				break
			case 1:
				showTool1 = showTool1 === true ? false : true
				showTool0 = false
				showTool4 = false
				showTool9 = false
				break

			case 2:
				showTool2 = showTool2 === true ? false : true
				generalTool1 = false
				showTool3 = false
				if (showTool2) {
					if (!icon1) icon1Color = iconColor
					if (!icon2) icon2Color = iconColor
					if (!icon3) icon3Color = iconColor
					if (!icon4) icon4Color = iconColor
					if (!icon1 || !icon2 || !icon3 || !icon4) icon5Color = iconColor

					toTool = setTimeout(() => {
						icon1Color = icon1Color
						icon2Color = icon2Color
						icon3Color = icon3Color
						icon4Color = icon4Color
						icon5Color = icon5Color
					}, 10)
				}
				break

			case 3:
				showTool3 = showTool3 === true ? false : true
				generalTool1 = false
				showTool2 = false
				break

			case 4:
				showTool4 = showTool4 === true ? false : true
				showTool1 = false
				showTool0 = false
				showTool9 = false
				break

			case 5:
				showTool5 = showTool5 === true ? false : true
				generalTool2 = false
				showTool6 = false
				showTool7 = false
				showTool8 = false
				if (showTool5) {
					if (!icon6) icon6Color = iconColor
					if (!icon7) icon7Color = iconColor
					if (!icon8) icon8Color = iconColor
					if (!icon9) icon9Color = iconColor
					if (!icon6 || !icon7 || !icon8 || !icon9) icon10Color = iconColor

					toTool = setTimeout(() => {
						icon6Color = icon6Color
						icon7Color = icon7Color
						icon8Color = icon8Color
						icon9Color = icon9Color
						icon10Color = icon10Color
					}, 10)
				}
				break

			case 6:
				showTool6 = showTool6 === true ? false : true
				generalTool2 = false
				showTool5 = false
				showTool7 = false
				showTool8 = false
				break

			case 7:
				showTool7 = showTool7 === true ? false : true
				generalTool2 = false
				showTool6 = false
				showTool5 = false
				showTool8 = false
				break

			case 8:
				showTool8 = showTool8 === true ? false : true
				generalTool2 = false
				showTool6 = false
				showTool7 = false
				showTool5 = false
				break

			case 9:
				showTool9 = showTool9 === true ? false : true
				showTool1 = false
				showTool4 = false
				showTool0 = false
				break

			case 10:
				showTool10 = showTool10 === true ? false : true
				generalTool3 = false
				showTool11 = false
				showTool12 = false
				break

			case 11:
				showTool11 = showTool11 === true ? false : true
				generalTool3 = false
				showTool10 = false
				showTool12 = false
				break

			case 12:
				showTool12 = showTool12 === true ? false : true
				generalTool3 = false
				showTool11 = false
				showTool10 = false
				break
		}
	}

	onDestroy(() => {
		stoElementID
		stoData
		stoSelectedIcon
		stoAnimate
		stoShowGallery
		clearTimeout(toTool)
	})
</script>

{#if config}
	{#if !showGallery}
		<main use:styles={{ width }}>
			<div
				class="part_title mainTool"
				on:click={() => open_tool(0)}
				on:keydown={() => open_tool(0)}
				use:styles={{ mainTool, mainToolHover, fsXS }}
			>
				LAYOUT POSITION
			</div>
			{#if showTool0}
				<div transition:slide={{ duration: 500 }}>
					<div class="icon_container">
						<div
							class="icon arrow_down"
							use:styles={{ icon, iconColor, iconHover }}
							on:click={() => change_order(blockID, 'down')}
							on:keydown={() => change_order(blockID, 'down')}
						/>
						<div
							class="icon arrow_up"
							use:styles={{ icon, iconColor, iconHover }}
							on:click={() => change_order(blockID, 'up')}
							on:keydown={() => change_order(blockID, 'up')}
						/>
					</div>
				</div>
			{/if}
			<section>
				<div
					class="part_title mainTool"
					on:click={() => open_tool(1)}
					on:keydown={() => open_tool(1)}
					use:styles={{ mainTool, mainToolHover, fsXS }}
				>
					MAIN CONTAINER
				</div>
				{#if showTool1}
					<div transition:slide={{ duration: 500 }}>
						<div
							class="part_title subTool"
							on:click={() => open_tool('generalTool1')}
							on:keydown={() => open_tool('generalTool1')}
							use:styles={{ subTool, subToolHover, fsXS }}
						>
							general
						</div>
						{#if generalTool1}
							<div transition:slide={{ duration: 500 }}>
								<div class="sub_title_small" use:styles={{ fsXS }}>Background Color</div>
								<ColorSelector
									on:setcolor={set_bg_color}
									on:setopacity={set_bg_color}
									on:settransparent={set_bg_color}
									ID={idColor1}
									transparent="1"
									selectedColor={selectedBackground}
									initialValue={selectedBgOpac}
								/>
								<div class="sub_title_small" use:styles={{ fsXS }}>Margin Top</div>
								<SizeSelector
									ID={idMarginTop}
									range="20"
									initialValue={selectedMarginTop}
									on:sizechange={set_margin_top}
								/>

								<div class="sub_title_small" use:styles={{ fsXS }}>Margin Bottom</div>
								<SizeSelector
									ID={idMarginBottom}
									range="20"
									initialValue={selectedMarginBottom}
									on:sizechange={set_margin_bottom}
								/>

								<div class="sub_title_small" use:styles={{ fsXS }}>Padding</div>
								<SizeSelector ID={idPadding} range="20" initialValue={selectedPadding} on:sizechange={set_padding} />
							</div>
						{/if}
						<div
							class="part_title subTool"
							on:click={() => open_tool(2)}
							on:keydown={() => open_tool(2)}
							use:styles={{ subTool, subToolHover, fsXS }}
						>
							border
						</div>
						{#if showTool2}
							<div transition:slide={{ duration: 500 }}>
								<div class="icon_container">
									<div
										id="icon1"
										class="icon icon1"
										use:styles={{ icon, icon1Color, iconHover }}
										on:click={set_icon_1}
										on:keydown={set_icon_1}
									/>
									<div
										id="icon2"
										class="icon icon2"
										use:styles={{ icon, icon2Color, iconHover }}
										on:click={set_icon_2}
										on:keydown={set_icon_2}
									/>
									<div
										id="icon3"
										class="icon icon3"
										use:styles={{ icon, icon3Color, iconHover }}
										on:click={set_icon_3}
										on:keydown={set_icon_3}
									/>
									<div
										id="icon4"
										class="icon icon4"
										use:styles={{ icon, icon4Color, iconHover }}
										on:click={set_icon_4}
										on:keydown={set_icon_4}
									/>
									<div
										id="icon5"
										class="icon icon5"
										use:styles={{ icon, icon5Color, iconHover }}
										on:click={set_icon_5}
										on:keydown={set_icon_5}
									/>
								</div>
								{#if iconP1Selected}
									<div in:slide={{ duration: 500 }}>
										<div class="sub_title_small" use:styles={{ fsXS }}>Border Color</div>
										<ColorSelector
											on:setcolor={set_gallery_border_color}
											on:setopacity={set_gallery_border_color}
											ID={idColor2}
											selectedColor={selectedBorderColor}
											initialValue={selectedBgOpac}
										/>

										<div class="sub_title_small" use:styles={{ fsXS }}>Border Width</div>
										<SizeSelector
											ID={idBorderWidth}
											range="50"
											unit="px"
											initialValue={selectedBorderWidth}
											on:sizechange={set_border_width}
										/>

										<div class="sub_title_small" use:styles={{ fsXS }}>Border Top Radius</div>
										<SizeSelector
											ID={idBTradius}
											unit="px"
											initialValue={selectedBTradius}
											range="20"
											on:sizechange={set_border_top_radius}
										/>

										<div class="sub_title_small" use:styles={{ fsXS }}>Border Bottom Radius</div>
										<SizeSelector
											ID={idBBradius}
											initialValue={selectedBBradius}
											range="20"
											unit="px"
											on:sizechange={set_border_bottom_radius}
										/>
									</div>
								{/if}
							</div>
						{/if}

						<div
							class="part_title subTool"
							on:click={() => open_tool(3)}
							on:keydown={() => open_tool(3)}
							use:styles={{ subTool, subToolHover, fsXS }}
						>
							shadow
						</div>
						{#if showTool3}
							<div transition:slide={{ duration: 500 }}>
								<div class="sub_title_small" use:styles={{ fsXS }}>Shadow</div>
								<ColorSelector
									on:setcolor={set_shadow_color}
									on:setopacity={set_shadow_color}
									ID={idColor7}
									selectedColor={selectedSColor}
									selectedOpac={selectedSOpac}
								/>

								<div class="sub_title_small" use:styles={{ fsXS }}>Offset Y</div>
								<SizeSelector
									ID={idShadowY}
									range="20"
									unit="px"
									initialValue={selectedSY}
									on:sizechange={set_offset_y}
								/>

								<div class="sub_title_small" use:styles={{ fsXS }}>Blur</div>
								<SizeSelector
									ID={idShadowBlur}
									range="20"
									unit="px"
									initialValue={selectedSBlur}
									on:sizechange={set_blur}
								/>
							</div>
						{/if}
					</div>
				{/if}
			</section>
			<section>
				<div
					class="part_title mainTool"
					on:click={() => open_tool(4)}
					on:keydown={() => open_tool(4)}
					use:styles={{ mainTool, mainToolHover, fsXS }}
				>
					LEFT CONTAINER
				</div>
				{#if showTool4}
					<div transition:slide={{ duration: 500 }}>
						<div
							class="part_title subTool"
							on:click={() => open_tool('generalTool2')}
							on:keydown={() => open_tool('generalTool2')}
							use:styles={{ subTool, subToolHover, fsXS }}
						>
							general
						</div>
						{#if generalTool2}
							<div transition:slide={{ duration: 500 }}>
								<div class="sub_title_small" use:styles={{ fsXS }}>background</div>
								<ColorSelector
									on:setcolor={set_gallery_lc_bg_color}
									on:setopacity={set_gallery_lc_bg_color}
									on:settransparent={set_gallery_lc_bg_color}
									transparent="1"
									ID={idColor3}
									selectedColor={selectedLBgColor}
									initialValue={selectedLBgOpac}
								/>
								<div class="sub_title_small" use:styles={{ fsXS }}>Margin top</div>
								<SizeSelector
									ID={idGalleryClMt}
									initialValue={selectedLMarginTop}
									range="20"
									unit="%"
									on:sizechange={set_gallery_lc_margin_top}
								/>

								<div class="sub_title_small" use:styles={{ fsXS }}>Margin bottom</div>
								<SizeSelector
									ID={idGalleryClMb}
									initialValue={selectedLMarginBottom}
									range="20"
									on:sizechange={set_gallery_lc_margin_bottom}
								/>

								<div class="sub_title_small" use:styles={{ fsXS }}>Padding</div>
								<SizeSelector
									ID={idGalleryClP}
									initialValue={selectedLPadding}
									range="20"
									unit="%"
									on:sizechange={set_gallery_lc_padding}
								/>
							</div>
						{/if}
					</div>

					<div
						class="part_title subTool"
						on:click={() => open_tool(5)}
						on:keydown={() => open_tool(5)}
						use:styles={{ subTool, subToolHover, fsXS }}
					>
						border
					</div>
					{#if showTool5}
						<div transition:slide={{ duration: 500 }}>
							<div class="icon_container">
								<div
									id="icon6"
									class="icon icon6"
									use:styles={{ icon, icon6Color, iconHover }}
									on:click={set_icon_6}
									on:keydown={set_icon_6}
								/>
								<div
									id="icon7"
									class="icon icon7"
									use:styles={{ icon, icon7Color, iconHover }}
									on:click={set_icon_7}
									on:keydown={set_icon_7}
								/>
								<div
									id="icon8"
									class="icon icon8"
									use:styles={{ icon, icon8Color, iconHover }}
									on:click={set_icon_8}
									on:keydown={set_icon_8}
								/>
								<div
									id="icon9"
									class="icon icon9"
									use:styles={{ icon, icon9Color, iconHover }}
									on:click={set_icon_9}
									on:keydown={set_icon_9}
								/>
								<div
									id="icon10"
									class="icon icon10"
									use:styles={{ icon, icon10Color, iconHover }}
									on:click={set_icon_10}
									on:keydown={set_icon_10}
								/>
							</div>
							{#if iconP2Selected}
								<div in:slide={{ duration: 500 }}>
									<div class="sub_title_small" use:styles={{ fsXS }}>Border Color</div>
									<ColorSelector
										on:setcolor={set_gallery_left_border_color}
										on:setopacity={set_gallery_left_border_color}
										ID={idColor4}
										selectedColor={selectedLBcolor}
										initialValue={selectedLBopac}
									/>

									<div class="sub_title_small" use:styles={{ fsXS }}>Border Width</div>
									<SizeSelector
										ID={idGLB}
										range="20"
										unit="px"
										initialValue={selectedGalleryLeftBorderWidth}
										on:sizechange={set_gallery_left_border_width}
									/>

									<div class="sub_title_small" use:styles={{ fsXS }}>Border Top Radius</div>

									<SizeSelector
										ID={idGLBTRadius}
										range="20"
										unit="px"
										initialValue={selectedLBTLradius}
										on:sizechange={set_gallery_left_border_top_radius}
									/>

									<div class="sub_title_small" use:styles={{ fsXS }}>Border Bottom Radius</div>
									<SizeSelector
										ID={idGLBBradius}
										initialValue={selectedLBBLradius}
										range="20"
										unit="px"
										on:sizechange={set_gallery_left_border_bottom_radius}
									/>
								</div>
							{/if}
						</div>
					{/if}
					<div
						class="part_title subTool"
						on:click={() => open_tool(6)}
						on:keydown={() => open_tool(6)}
						use:styles={{ subTool, subToolHover, fsXS }}
					>
						font
					</div>
					{#if showTool6}
						<div transition:slide={{ duration: 500 }}>
							<div class="sub_title_small" use:styles={{ fsXS }}>Font Color</div>
							<ColorSelector
								on:setcolor={set_gallery_intro_font_color}
								on:setopacity={set_gallery_intro_font_color}
								ID={idColor5}
								selectedColor={selectedLFontColor}
								initialValue={selectedLFontOpac}
							/>
							<div class="sub_title_small" use:styles={{ fsXS }}>Font Family</div>
							<SelectValues
								options={fontFamily}
								on:select={set_gallery_intro_font_family}
								value={selectedLFontFamily}
								ID={idSelect1}
							/>
							<div class="sub_title_small" use:styles={{ fsXS }}>Font Size</div>
							<SelectValues
								options={fontSize}
								on:select={set_gallery_left_font_size}
								value={selectedLFontSize}
								ID={idSelect2}
							/>
							<div class="sub_title_small" use:styles={{ fsXS }}>Font Decoration</div>
							<div class="icon_container">
								<div
									id="fweight"
									class="icon iconWeight"
									use:styles={{ icon, iconWeight, iconHover }}
									on:click={set_gallery_intro_font_weight}
									on:keydown={set_gallery_intro_font_weight}
								/>
								<div
									id="fstyle"
									class="icon iconStyle"
									use:styles={{ icon, iconStyle, iconHover }}
									on:click={set_gallery_left_font_style}
									on:keydown={set_gallery_left_font_style}
								/>
								<div />
								<div />
							</div>
						</div>
					{/if}

					<div
						class="part_title subTool"
						on:click={() => open_tool(7)}
						on:keydown={() => open_tool(7)}
						use:styles={{ subTool, subToolHover, fsXS }}
					>
						alignment
					</div>
					{#if showTool7}
						<div transition:slide={{ duration: 500 }}>
							<div class="sub_title_small" use:styles={{ fsXS }}>Text Alignment</div>
							<div class="icon_container">
								<div
									id="fAlignL"
									class="icon txtAlignL"
									use:styles={{ icon, iconAlignL, iconHover }}
									on:click={() => set_gallery_intro_align('left')}
									on:keydown={() => set_gallery_intro_align('left')}
								/>

								<div
									id="fAlignC"
									class="icon txtAlignC"
									use:styles={{ icon, iconAlignC, iconHover }}
									on:click={() => set_gallery_intro_align('center')}
									on:keydown={() => set_gallery_intro_align('center')}
								/>

								<div
									id="fAlignR"
									class="icon txtAlignR"
									use:styles={{ icon, iconAlignR, iconHover }}
									on:click={() => set_gallery_intro_align('right')}
									on:keydown={() => set_gallery_intro_align('right')}
								/>
							</div>

							<div class="icon_container">
								<div
									id="vAlignT"
									class="icon txtValignT"
									use:styles={{ icon, iconValignT, iconHover }}
									on:click={set_gallery_left_valign_top}
									on:keydown={set_gallery_left_valign_top}
								/>

								<div
									id="vAlignC"
									class="icon txtValignC"
									use:styles={{ icon, iconValignC, iconHover }}
									on:click={set_gallery_left_valign_center}
									on:keydown={set_gallery_left_valign_center}
								/>

								<div
									id="vAlignB"
									class="icon txtValignB"
									use:styles={{ icon, iconValignB, iconHover }}
									on:click={set_gallery_left_valign_bottom}
									on:keydown={set_gallery_left_valign_bottom}
								/>
							</div>
						</div>
					{/if}

					<div
						class="part_title subTool"
						on:click={() => open_tool(8)}
						on:keydown={() => open_tool(8)}
						use:styles={{ subTool, subToolHover, fsXS }}
					>
						shadow
					</div>
					{#if showTool8}
						<div transition:slide={{ duration: 500 }}>
							<div class="sub_title_small" use:styles={{ fsXS }}>Color</div>
							<ColorSelector
								on:setcolor={set_gallery_left_shadow_color}
								on:setopacity={set_gallery_left_shadow_color}
								ID={idColor10}
								selectedColor={selectedSLeftColor}
								initialValue={selectedSLeftOpac}
							/>

							<div class="sub_title_small" use:styles={{ fsXS }}>Offset X</div>
							<SizeSelector
								ID={idLeftShadowX}
								initialValue={selectedSLeftX}
								range="20"
								unit="px"
								on:sizechange={set_gallery_left_shadow_x}
							/>

							<div class="sub_title_small" use:styles={{ fsXS }}>Offset Y</div>
							<SizeSelector
								ID={idLeftShadowY}
								initialValue={selectedSLeftY}
								range="20"
								unit="px"
								on:sizechange={set_gallery_left_shadow_y}
							/>

							<div class="sub_title_small" use:styles={{ fsXS }}>Blur</div>
							<SizeSelector
								ID={idLeftShadowB}
								initialValue={selectedSLeftBlur}
								range="20"
								unit="px"
								on:sizechange={set_gallery_left_shadow_blur}
							/>
						</div>
					{/if}
				{/if}
			</section>
			<section>
				<div
					class="part_title mainTool"
					on:click={() => open_tool(9)}
					on:keydown={() => open_tool(9)}
					use:styles={{ mainTool, mainToolHover, fsXS }}
				>
					RIGHT CONTAINER
				</div>
				{#if showTool9}
					<div transition:slide={{ duration: 500 }}>
						<div
							class="part_title subTool"
							on:click={() => open_tool('generalTool3')}
							on:keydown={() => open_tool('generalTool3')}
							use:styles={{ subTool, subToolHover, fsXS }}
						>
							general
						</div>
						{#if generalTool3}
							<div transition:slide={{ duration: 500 }}>
								<div class="sub_title_small" use:styles={{ fsXS }}>background</div>
								<ColorSelector
									on:setcolor={set_gallery_rc_bg_color}
									on:setopacity={set_gallery_rc_bg_color}
									on:settransparent={set_gallery_rc_bg_color}
									transparent="1"
									ID={idColor6}
									selectedColor={selectedRBgColor}
									initialValue={selectedRBgOpac}
								/>
								<div class="sub_title_small" use:styles={{ fsXS }}>Margin top</div>
								<SizeSelector
									ID={idGalleryCrMt}
									initialValue={selectedRMarginTop}
									range="20"
									unit="%"
									on:sizechange={set_gallery_rc_margin_top}
								/>

								<div class="sub_title_small" use:styles={{ fsXS }}>Margin bottom</div>
								<SizeSelector
									ID={idGalleryCrMb}
									initialValue={selectedRMarginBottom}
									range="20"
									on:sizechange={set_gallery_rc_margin_bottom}
								/>

								<div class="sub_title_small" use:styles={{ fsXS }}>Padding</div>
								<SizeSelector
									ID={idGalleryCrP}
									initialValue={selectedRPadding}
									range="20"
									unit="%"
									on:sizechange={set_gallery_rc_padding}
								/>
							</div>
						{/if}
						<div
							class="part_title subTool"
							on:click={() => open_tool(10)}
							on:keydown={() => open_tool(10)}
							use:styles={{ subTool, subToolHover, fsXS }}
						>
							border
						</div>
						{#if showTool10}
							<div transition:slide={{ duration: 500 }}>
								<div class="sub_title_small" use:styles={{ fsXS }}>Border</div>
								<div class="icon_container">
									<div
										id="icon11"
										class="icon icon11"
										use:styles={{ icon, icon11Color, iconHover }}
										on:click={set_icon_11}
										on:keydown={set_icon_11}
									/>
									<div
										id="icon12"
										class="icon icon12"
										use:styles={{ icon, icon12Color, iconHover }}
										on:click={set_icon_12}
										on:keydown={set_icon_12}
									/>
									<div
										id="icon13"
										class="icon icon13"
										use:styles={{ icon, icon13Color, iconHover }}
										on:click={set_icon_13}
										on:keydown={set_icon_13}
									/>
									<div
										id="icon14"
										class="icon icon14"
										use:styles={{ icon, icon14Color, iconHover }}
										on:click={set_icon_14}
										on:keydown={set_icon_14}
									/>
									<div
										id="icon15"
										class="icon icon15"
										use:styles={{ icon, icon15Color, iconHover }}
										on:click={set_icon_15}
										on:keydown={set_icon_15}
									/>
								</div>
								{#if iconP3Selected}
									<div in:slide={{ duration: 500 }}>
										<div class="sub_title_small" use:styles={{ fsXS }}>Border Color</div>
										<ColorSelector
											on:setcolor={set_gallery_right_border_color}
											on:setopacity={set_gallery_right_border_color}
											ID={idColor8}
											selectedColor={selectedLBcolor}
											initialValue={selectedLBopac}
										/>

										<div class="sub_title_small" use:styles={{ fsXS }}>Border Width</div>
										<SizeSelector
											ID={idGRB}
											range="20"
											unit="px"
											initialValue={selectedGalleryRightBorderWidth}
											on:sizechange={set_gallery_right_border_width}
										/>

										<div class="sub_title_small" use:styles={{ fsXS }}>Border Top Radius</div>

										<SizeSelector
											ID={idGRBTRadius}
											range="20"
											unit="px"
											initialValue={selectedRBTRradius}
											on:sizechange={set_gallery_right_border_top_radius}
										/>

										<div class="sub_title_small" use:styles={{ fsXS }}>Border Bottom Radius</div>
										<SizeSelector
											ID={idGRBBradius}
											initialValue={selectedRBBRradius}
											range="20"
											unit="px"
											on:sizechange={set_gallery_right_border_bottom_radius}
										/>
									</div>
								{/if}
							</div>
						{/if}

						<div
							class="part_title subTool"
							on:click={() => open_tool(11)}
							on:keydown={() => open_tool(11)}
							use:styles={{ subTool, subToolHover, fsXS }}
						>
							alignment
						</div>
						{#if showTool11}
							<div transition:slide={{ duration: 500 }}>
								<div class="icon_container">
									<div
										id="fAlignGRL"
										class="icon txtAlignRL"
										use:styles={{ icon, iconAlignRL, iconHover }}
										on:click={set_gallery_right_align_left}
										on:keydown={set_gallery_right_align_left}
									/>

									<div
										id="fAlignGRC"
										class="icon txtAlignRC"
										use:styles={{ icon, iconAlignRC, iconHover }}
										on:click={set_gallery_right_align_center}
										on:keydown={set_gallery_right_align_center}
									/>

									<div
										id="fAlignGRR"
										class="icon txtAlignRR"
										use:styles={{ icon, iconAlignRR, iconHover }}
										on:click={set_gallery_right_align_right}
										on:keydown={set_gallery_right_align_right}
									/>
								</div>
							</div>
						{/if}
						<div
							class="part_title subTool"
							on:click={() => open_tool(12)}
							on:keydown={() => open_tool(12)}
							use:styles={{ subTool, subToolHover, fsXS }}
						>
							shadow
						</div>
						{#if showTool12}
							<div transition:slide={{ duration: 500 }}>
								<ColorSelector
									on:setcolor={set_gallery_right_shadow_color}
									on:setopacity={set_gallery_right_shadow_color}
									ID={idColor9}
									selectedColor={selectedSRightColor}
									initialValue={selectedSRightOpac}
								/>

								<div class="sub_title_small" use:styles={{ fsXS }}>Offset X</div>
								<SizeSelector
									ID={idRightShadowX}
									initialValue={selectedSRightX}
									range="20"
									unit="px"
									on:sizechange={set_gallery_right_shadow_x}
								/>

								<div class="sub_title_small" use:styles={{ fsXS }}>Offset Y</div>
								<SizeSelector
									ID={idRightShadowY}
									initialValue={selectedSRightY}
									range="20"
									unit="px"
									on:sizechange={set_gallery_right_shadow_y}
								/>

								<div class="sub_title_small" use:styles={{ fsXS }}>Blur</div>
								<SizeSelector
									ID={idRightShadowB}
									initialValue={selectedSRightBlur}
									range="20"
									unit="px"
									on:sizechange={set_gallery_right_shadow_blur}
								/>
							</div>
						{/if}
						<div
							class="part_title subTool"
							use:styles={{ subTool, subToolHover, fsXS }}
							on:click={() => set_elementID('gallery_image_1')}
							on:keydown={() => set_elementID('gallery_image_1')}
						>
							image
						</div>
					</div>
				{/if}
			</section>
			<div
				class="part_title mainTool"
				on:click={open_set_modal}
				on:keydown={open_set_modal}
				use:styles={{ mainTool, mainToolHover, fsXS }}
			>
				GALLERY
			</div>
		</main>
	{/if}
{/if}

{#if shaderChangeOrder}
	<Shader>
		<div slot="content">
			<Spinner color="hsl(0,0%,60%)" info="change block order" />
		</div>
	</Shader>
{/if}

<style>
	main {
		width: var(--with);
		user-select: none;
		z-index: 2000;
	}

	.sub_title_small {
		display: flex;
		justify-content: space-between;
		align-items: center;
		width: 100%;
		background: hsl(0, 0%, 70%);
		color: black;
		font-size: var(--fsS);
		padding: 10px;
	}

	.sub_title_small {
		font-size: var(--fsXS);
		padding: 5px 0px 0px 10px;
	}

	.part_title {
		display: flex;
		width: 100%;
		justify-content: center;
		border-bottom: none;
		font-size: var(--fsXS);
		font-weight: bold;
		background-color: chocolate;
		padding: 10px;
		margin-top: 10px;
		cursor: pointer;
	}

	.icon_container {
		display: grid;
		grid-template-columns: repeat(auto-fit, minmax(40px, 1fr));
		padding: 2%;
	}

	.icon {
		display: inline-block;
		width: var(--icon);
		height: var(--icon);
		mask-size: cover;
		-webkit-mask-size: cover;
		cursor: pointer;
	}

	.icon:hover {
		background-color: var(--iconHover);
	}

	.arrow_down {
		background-color: var(--iconColor);
		mask: url('/images/tools/arrow_down.svg') no-repeat;
		-webkit-mask: url('/images/tools/arrow_down.svg') no-repeat;
	}

	.arrow_up {
		background-color: var(--iconColor);
		mask: url('/images/tools/arrow_up.svg') no-repeat;
		-webkit-mask: url('/images/tools/arrow_up.svg') no-repeat;
	}

	.icon1,
	.icon6,
	.icon11 {
		mask: url('/images/tools/borderL.svg') no-repeat;
		-webkit-mask: url('/images/tools/borderL.svg') no-repeat;
	}

	.icon1 {
		background-color: var(--icon1Color);
	}

	.icon6 {
		background-color: var(--icon6Color);
	}

	.icon11 {
		background-color: var(--icon11Color);
	}

	.icon2,
	.icon7,
	.icon12 {
		mask: url('/images/tools/borderT.svg') no-repeat;
		-webkit-mask: url('/images/tools/borderT.svg') no-repeat;
	}

	.icon2 {
		background-color: var(--icon2Color);
	}

	.icon7 {
		background-color: var(--icon7Color);
	}

	.icon12 {
		background-color: var(--icon12Color);
	}

	.icon3,
	.icon8,
	.icon13 {
		mask: url('/images/tools/borderR.svg') no-repeat;
		-webkit-mask: url('/images/tools/borderR.svg') no-repeat;
	}

	.icon3 {
		background-color: var(--icon3Color);
	}

	.icon8 {
		background-color: var(--icon8Color);
	}

	.icon13 {
		background-color: var(--icon13Color);
	}

	.icon4,
	.icon9,
	.icon14 {
		mask: url('/images/tools/borderB.svg') no-repeat;
		-webkit-mask: url('/images/tools/borderB.svg') no-repeat;
	}

	.icon4 {
		background-color: var(--icon4Color);
	}

	.icon9 {
		background-color: var(--icon9Color);
	}

	.icon14 {
		background-color: var(--icon14Color);
	}

	.icon5,
	.icon10,
	.icon15 {
		mask: url('/images/tools/borderA.svg') no-repeat;
		-webkit-mask: url('/images/tools/borderA.svg') no-repeat;
	}

	.icon5 {
		background-color: var(--icon5Color);
	}

	.icon10 {
		background-color: var(--icon10Color);
	}

	.icon15 {
		background-color: var(--icon15Color);
	}

	.iconWeight {
		background-color: var(--iconWeight);
		mask: url('/images/tools/fontB.svg') no-repeat;
		-webkit-mask: url('/images/tools/fontB.svg') no-repeat;
	}

	.iconStyle {
		background-color: var(--iconStyle);
		mask: url('/images/tools/fontI.svg') no-repeat;
		-webkit-mask: url('/images/tools/fontI.svg') no-repeat;
	}

	.txtAlignL {
		background-color: var(--iconAlignL);
		mask: url('/images/tools/alignL.svg') no-repeat;
		-webkit-mask: url('/images/tools/alignL.svg') no-repeat;
	}

	.txtAlignRL {
		background-color: var(--iconAlignRL);
		mask: url('/images/tools/alignL.svg') no-repeat;
		-webkit-mask: url('/images/tools/alignL.svg') no-repeat;
	}

	.txtAlignC {
		background-color: var(--iconAlignC);
		mask: url('/images/tools/alignC.svg') no-repeat;
		-webkit-mask: url('/images/tools/alignC.svg') no-repeat;
	}

	.txtAlignRC {
		background-color: var(--iconAlignRC);
		mask: url('/images/tools/alignC.svg') no-repeat;
		-webkit-mask: url('/images/tools/alignC.svg') no-repeat;
	}

	.txtAlignR {
		background-color: var(--iconAlignR);
		mask: url('/images/tools/alignR.svg') no-repeat;
		-webkit-mask: url('/images/tools/alignR.svg') no-repeat;
	}

	.txtAlignRR {
		background-color: var(--iconAlignRR);
		mask: url('/images/tools/alignR.svg') no-repeat;
		-webkit-mask: url('/images/tools/alignR.svg') no-repeat;
	}

	.txtValignT {
		background-color: var(--iconValignT);
		mask: url('/images/tools/valignT.svg') no-repeat;
		-webkit-mask: url('/images/tools/valignT.svg') no-repeat;
	}

	/* .txtValignRT {
		background-color: var(--iconValignRT);
		mask: url('/images/tools/valignT.svg') no-repeat;
		-webkit-mask: url('/images/tools/valignT.svg') no-repeat;
	} */

	.txtValignC {
		background-color: var(--iconValignC);
		mask: url('/images/tools/valignC.svg') no-repeat;
		-webkit-mask: url('/images/tools/valignC.svg') no-repeat;
	}

	/* .txtValignRC {
		background-color: var(--iconValignRC);
		mask: url('/images/tools/valignC.svg') no-repeat;
		-webkit-mask: url('/images/tools/valignC.svg') no-repeat;
	} */

	.txtValignB {
		background-color: var(--iconValignB);
		mask: url('/images/tools/valignB.svg') no-repeat;
		-webkit-mask: url('/images/tools/valignB.svg') no-repeat;
	}

	/* .txtValignRB {
		background-color: var(--iconValignRB);
		mask: url('/images/tools/valignB.svg') no-repeat;
		-webkit-mask: url('/images/tools/valignB.svg') no-repeat;
	} */

	.mainTool {
		background-color: var(--mainTool);
	}

	.mainTool:hover {
		background-color: var(--mainToolHover);
	}

	.subTool {
		background-color: var(--subTool);
	}

	.subTool:hover {
		background-color: var(--subToolHover);
	}
</style>
